"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ControlLabel;

var _react = _interopRequireDefault(require("react"));

var LabelPrimitive = _interopRequireWildcard(require("@radix-ui/react-label"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ControlLabel(_ref) {
  var id = _ref.id,
      text = _ref.text,
      aside = _ref.aside,
      optional = _ref.optional,
      _ref$themeLabel = _ref.themeLabel,
      themeLabel = _ref$themeLabel === void 0 ? 'txt-s txt-bold mb6' : _ref$themeLabel;
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(LabelPrimitive.Root, {
    htmlFor: id,
    asChild: true
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: "inline-block ".concat(themeLabel)
  }, text, " ", optional && /*#__PURE__*/_react.default.createElement("span", {
    className: "txt-normal"
  }, "(optional)"))), aside && /*#__PURE__*/_react.default.createElement("span", {
    className: "inline-block ml12"
  }, aside));
}

ControlLabel.propTypes = {
  /** Value should match the identifying id of the input element. */
  id: _propTypes.default.string.isRequired,

  /** Label text */
  text: _propTypes.default.string.isRequired,

  /** Additional content to provide aligned to the right of the label. */
  aside: _propTypes.default.node,

  /** If true, label text adds (optional) alongside it. */
  optional: _propTypes.default.bool,

  /** A space separated list of Assembly class names to override the existing presentation. */
  themeLabel: _propTypes.default.string
};